<template>

    <v-dialog 
        v-model="open" 
        max-width="360px" 
        transition="slide-y-transition" 
        persistent
    >

    <div v-if="isLoading">
        <h3>Enviando</h3>
        <v-row justify="center" class="py-4" no-gutters>
            <v-progress-circular indeterminate size="40" width="4" color="primary"></v-progress-circular>
        </v-row>
    </div>
    
    <div v-if="!isLoading">

        <div v-if="!rated">

            <h3>Avalie o Atendimento</h3>
            
            <div class="star-wrapper">
                <vue-stars
                    name="demo"
                    active-color="#ffdd00"
                    inactive-color="#999999"
                    shadow-color="#ffff00"
                    hover-color="#dddd00"
                    :max="5"
                    v-model="rating"
                    char="★"
                />
            </div>

            <textarea v-model="comment" rows="3" placeholder="Deixar Comentário"></textarea>

            <v-btn block color="primary" @click="save">
                <span>Avaliar</span> 
            </v-btn>

        </div>

        <div v-if="rated">
            <h3>Obrigado por avaliar</h3>

            <div class="icon-wrapper">
                <v-icon size="60" color="primary">mdi-comment-check-outline</v-icon>
            </div>
            
        </div>
    </div>

    </v-dialog>

</template>

<script>
import { VueStars } from "vue-stars";

export default {
    name: "Rating",
    components: {
        VueStars
    },
    data: () => ({
        isLoading: false,
        open: true,
        rating: 3,
        rated: false,
        comment: null
    }),
    mounted(){
        
    },
    watch: {
        open: {
            handler(newValue){
                if(!newValue) this.$emit("closeModal");
            }
        }
    },
    methods: {
        save(){
            const { roomID } = this.$route.params;
            this.isLoading = true;
            this.$socket.emit("atendimentos_avaliacao", { estrelas: this.rating, comentario: this.comment, atendimento_id: Number(roomID) });
        }
    },
    sockets:{
      atendimentos_avaliacao: function({error}){
        this.isLoading = false;
        if(!error) {
            this.rated = true;
            localStorage.removeItem("@bsi:user");
        }
      },
    }
}

</script>

<style lang="scss">

    .v-dialog{
        position: relative;
        overflow: hidden;
        background-color: var(--v-secondary-base);
        padding: 30px;

        textarea{
            display: block;
            border: 1px solid var(--v-texts-base);
            width: 100%;
            margin-bottom: 20px;
            color: var(--v-texts-base);;
            padding: 10px;
            font-size: 13px;
            border-radius: 6px;
            &::placeholder{
                color: var(--v-texts-base);
                opacity: .75;
            }
            &:focus{
                outline: none;
            }
        }

        h3{
            text-align: center;
            font-weight: 400;
            font-size: 18px;
        }

        .icon-wrapper{
            padding-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        
        .star-wrapper{
            width: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px 0;

            .vue-stars{
                font-size: 34px;
            }
        }
    }

</style>